import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function HeroSection({ data }) {
  const [hero, setHero] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (data) {
      setHero(data);
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await fetch("https://backend.ohanyanlegal.am/688787d8ff144c502c7/api/home/page/");
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data) {
          setHero(data);
        } else {
          setHero(null);
        }
      } catch (error) {
        console.error("Fetch error:", error);
        setError("Failed to load hero section");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [data]);

  if (loading) {
    return (
      <section className="hero-section" style={{ minHeight: '500px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="container">
          <div className="text-center text-white">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading hero section...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="hero-section">
        <div className="container">
          <div className="text-center text-white py-5">
            <p>Error: {error}</p>
            <button 
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>
          </div>
        </div>
      </section>
    );
  }

  const heroData = hero || {};
  
  const bgImage = heroData.hero_background_image_url 
    ? `url(${heroData.hero_background_image_url})`
    : "url('/assets/img/bg-img/1.jpg')";

  const rightImage = heroData.hero_right_image_url || '/assets/img/bg-img/2.png';

  return (
    <section
      className="hero-section"
      style={{
        backgroundImage: bgImage,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative'
      }}
    >
      <div
        className="right-side-image wow fadeIn"
        data-wow-duration="1000ms"
        data-wow-delay="800ms"
      >
        <img 
          src={rightImage} 
          alt="Hero" 
          style={{ maxWidth: '100%', height: 'auto' }}
          onError={(e) => {
            e.target.src = '/assets/img/bg-img/2.png';
          }}
        />
      </div>

      <div className="container">
        <div className="row">
          <div className="col-12 col-md-9 col-lg-7 col-xxl-6">
            <div className="hero-content">
              <h2
                className="mb-4 wow fadeInUp text-white"
                data-wow-duration="1000ms"
                data-wow-delay="400ms"
              >
                {heroData.hero_title || "Professional Legal Services"}
              </h2>

              <p
                className="text-white wow fadeInUp"
                data-wow-duration="1000ms"
                data-wow-delay="600ms"
              >
                {heroData.hero_description || "We provide comprehensive legal solutions with expertise and dedication to achieve the best outcomes for our clients."}
              </p>

              <div className="d-flex flex-wrap align-items-center gap-4">
                <Link
                  to="/contact"
                  className="btn btn-primary wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="800ms"
                >
                  <span>
                    {heroData.hero_button_text || "Get Consultation"} <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    {heroData.hero_button_text || "Get Consultation"} <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="divider"></div>
    </section>
  );
}

export default HeroSection;